<template>
  <div class="uebersicht">

    <h1>Alle eingetragenen Helfer hier Anzeigen</h1>

    <section class="container">
      <div class="columns">
        <div class="column">

          <div
            class="user-list"
            v-for="schicht in schichten"
            :key="schicht.id"
          >
            <div class="card card-shadow">
              <header class="card-header">
                <p class="user-list__header">
                  {{schicht.tag}} {{schicht.zeit}} {{schicht.bereich}}</p>
              </header>
              <div class="card-content">
                <!-- <div class="left">
                  <p class="user-list__sub">
                    <strong>Zeit</strong>: {{schicht.zeit}}</p>

                </div>
                <div class="right">
                  <p class="user-list__sub">
                    <strong>Bereich</strong>: {{schicht.bereich}}</p>
                </div> -->
                <div class="right">
                  <p class="user-list__sub">
                    <strong>Freie Plätze</strong>: {{schicht.anzahl}}</p>
                </div>

                <form @submit.prevent="mitarbeiterHinzufuegen(schicht)">

                  <div class="field">
                    <label class="label">Hinzufügen</label>

                    <div class="control">
                      <input
                        class="input"
                        type="email"
                        placeholder="Mailadresse"
                        v-model="mailadresse"
                        required
                      >
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <button
                        type="submit"
                        class="button is-link"
                      >Submit</button>
                    </div>
                  </div>

                </form>

                <div class="center">
                  <p>
                    <strong>In dieser Schicht</strong>
                  </p>
                  <p
                    v-for="arbeiter in schicht.arbeiter"
                    :key="arbeiter.id"
                    class="user-list__sub"
                  > {{arbeiter.name}} <button
                      class="button is-danger"
                      v-on:click="deleteHelferInSchicht(arbeiter, schicht)"
                    >Löschen</button> </p>
                </div>
              </div>

            </div>
          </div>

          <table style="table">
            <tr>
              <th>Tag</th>
              <th>Zeit</th>
              <th>Bereich</th>
              <th>Freie Plätze</th>
              <th> Helfer</th>
            </tr>
            <tr
              v-for="schicht in schichten"
              :key="schicht.id"
            >
              <td>{{schicht.tag}}</td>
              <td>{{schicht.zeit}}</td>
              <td>{{schicht.bereich}}</td>
              <td>{{schicht.anzahl}}</td>
              <td
                v-for="arbeiter in schicht.arbeiter"
                :key="arbeiter.id"
              >{{arbeiter.name}}</td>

            </tr>
          </table>

          <h1>alle Helfer</h1>

          <table style="table">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>T-Shirt</th>
            </tr>
            <tr
              v-for="person in users"
              :key="person.id"
            >
              <td>{{person.name}}</td>
              <td>{{person.email}}</td>
              <td>{{person.telNumber}}</td>
              <td>{{person.shirtsize}} </td>
            </tr>

          </table>

        </div>

      </div>
    </section>

  </div>
</template>

<script>
import firebase from 'firebase';




export default {
  name: 'uebersicht',
  data () {
    return {
      users: [],
      schichten: [],
      schicht: [],
      arbeiter: [],
      mailadresse: '',
      loading: true
    }
  },

  created () {
    this.getUsers()
    this.getSchichten()
  },
  methods: {
    getUsers () {
      firebase
        .firestore()
        .collection('users')
        // .where("userID", "==", firebase.auth().currentUser.uid)
        .get()

        .then(querySnapshot => {
          //    firebase.firestore().collection('users').get().then((querySnapshot) => {
          this.loading = false
          const users = []
          querySnapshot.forEach(doc => {
            let data = {
              id: doc.id,
              name: doc.data().displayName,
              email: doc.data().email,
              telNumber: doc.data().telNumber,
              userID: doc.data().userID,
              shirtsize: doc.data().shirtsize
            }
            users.push(data)
          })
          this.users = users
        })
    },
    getSchichten () {
      firebase
        .firestore()
        .collection('Schichten')
        .get()
        .then(querySnapshot => {
          const schichten = []
          this.loading = false
          querySnapshot.forEach(doc => {
            let data = {
              id: doc.id,
              tag: doc.data().tag,
              zeit: doc.data().zeit,
              dauer: doc.data().dauer,
              bereich: doc.data().bereich,
              anzahl: doc.data().anzahl,
              arbeiter: doc.data().arbeiter
            }
            schichten.push(data)
          })

          this.schichten = schichten
        })
    },
    deleteHelferInSchicht: function (arbeiter, schicht) {
      // Create a reference to the SF doc.
      let uid = arbeiter.uid;
      // let name = this.getUserforShichten();

      // const newArbeiter = { name };
      var schichtRef = firebase
        .firestore()
        .collection("Schichten/")
        .doc(schicht.id);

      return firebase
        .firestore()
        .runTransaction(function (transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(schichtRef).then(function (sfDoc) {
            if (!sfDoc.exists) {
              throw "Document does not exist!";
            }
            else if (sfDoc.data().arbeiter.some(i => i.uid === uid)) {
              var newAnzahl = sfDoc.data().anzahl + 1;
              transaction.update(schichtRef, { anzahl: newAnzahl });
              const arbeiter = sfDoc.data().arbeiter.filter(i => i.uid !== uid);
              transaction.update(schichtRef, { arbeiter });
            } else {
              alert("UPPS du bist bereits ausgetragen")
              location.reload();
              throw "Bereits ausgetragen";            }
          });
        })
        .then(this.getUsers)
        .then(this.getSchichten)
        .then(function () {
          // eslint-disable-next-line no-console
          console.log("Transaction successfully committed!");
        })
        .catch(function (error) {
          // eslint-disable-next-line no-console
          console.log("Transaction failed: ", error);
        });
    },


    mitarbeiterHinzufuegen (schicht) {
      firebase
        // find user from mail
        .firestore()
        .collection("users")
        .where("email", "==", this.mailadresse)
        .get()
        .then(querySnapshot => {
          //wenn user existiert weiter
          if (querySnapshot.empty === false) {
            this.loading = false
            //getUserData
            querySnapshot.forEach(doc => {
              let name = doc.data().displayName
              let uid = doc.data().userID

              //einschreiben
              const newArbeiter = { uid, name };
              var schichtRef = firebase
                .firestore()
                .collection("Schichten/")
                .doc(schicht.id);

              return firebase
                .firestore()
                .runTransaction(function (transaction) {
                  // This code may get re-run multiple times if there are conflicts.
                  return transaction.get(schichtRef).then(function (sfDoc) {
                    if (!sfDoc.exists) {
                      throw "Document does not exist!";
                    }
                    else if (sfDoc.data().anzahl === 0) {
                      alert("Leider bereits besetzt. Bitte Seite neu laden")
                      location.reload();
                      throw "schon Ausgebucht"
                    }
                    else if (sfDoc.data().arbeiter.some(i => i.uid === uid)) {
                      alert("Upps du bist schon in dieser Schicht")
                      location.reload();
                      throw "schon Ausgebucht"
                    }

                    var newAnzahl = sfDoc.data().anzahl - 1;
                    transaction.update(schichtRef, { anzahl: newAnzahl });

                    const arbeiter = sfDoc.data().arbeiter;

                    arbeiter.push(newArbeiter);
                    transaction.update(schichtRef, { arbeiter });
                  });
                })
                .then(this.getUsers)
                .then(this.getSchichten)

                .then(function () {
                  // eslint-disable-next-line no-console
                  console.log("Transaction successfully committed!");
                })
                .catch(function (error) {
                  // eslint-disable-next-line no-console
                  console.log("Transaction failed: ", error);
                });

            })
          } else { alert('Diese Mailadresse existiert nicht') }


        })




    },




  },


  // prevent unauthenticated users from accessing the admin area
  // and direct them to the login page
  // beforeRouteEnter (to, from, next) {
  //   // get the current logged in user
  //   firebase.auth().onAuthStateChanged(user => {
  //     if (user.email === 'moeruw@gmail.com') {
  //       // continue to /admin
  //       next()
  //     } else {
  //       // redirect to /login
  //       next('/login')
  //     }
  //   })
  // }
}

</script>

<style lang="scss" scoped>
h1 {
  font-size: 30px;
  margin: 30px 0;
}
.user-list {
  margin-top: 30px;
  background-color: white;
  padding: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
  .column {
    height: 120px;
  }
  .inner {
    .left {
      width: 50%;
      float: left;
      text-align: left;
    }
    .right {
      width: 50%;
      float: left;
      text-align: left;
      p {
        width: 100%;
        text-align: left;
      }
    }
    .center {
      width: 50%;
      float: left;
      text-align: left;
      p {
        width: 100%;
        text-align: left;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      background: #4b75ff;
    }
  }
  .user-list__header {
    font-size: 20px;
    font-weight: 700;
  }
  .user-list__sub {
    font-size: 15px;
    margin-top: 10px;
  }
}
@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
.animated-background__header {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-name: placeHolderShimmer;
  animation-name: placeHolderShimmer;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: #eeeeee;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(8%, #eeeeee),
    color-stop(18%, #dddddd),
    color-stop(33%, #eeeeee)
  );
  background: -webkit-linear-gradient(
    left,
    #eeeeee 8%,
    #dddddd 18%,
    #eeeeee 33%
  );
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  -webkit-background-size: 800px 104px;
  background-size: 800px 104px;
  height: 20px;
  width: 400px;
  position: relative;
}
.animated-background__sub {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-name: placeHolderShimmer;
  animation-name: placeHolderShimmer;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: #eeeeee;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(8%, #eeeeee),
    color-stop(18%, #dddddd),
    color-stop(33%, #eeeeee)
  );
  background: -webkit-linear-gradient(
    left,
    #eeeeee 8%,
    #dddddd 18%,
    #eeeeee 33%
  );
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  -webkit-background-size: 800px 104px;
  background-size: 800px 104px;
  height: 20px;
  width: 200px;
  position: relative;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
tr:nth-child(even) {
  background-color: #dddddd;
}
</style>
